import React, { ReactElement, ReactNode } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { NavbarStudyFields } from '@queries/generated/fragments.generated';

export interface StudySelectorItem extends Omit<NavbarStudyFields, 'shortName' | 'modules' | 'members' | 'smMembers'> {
    favourite: boolean;
    _isDefault: boolean;
}

interface StudySelectorListItemProps {
    li: ReactElement<HTMLLIElement>;
    dataItem: StudySelectorItem;
}

export const StudySelectorListItem = ({ li, dataItem }: StudySelectorListItemProps) => {
    const itemChildren = (
        <div className="k-display-flex k-w-full k-align-items-center k-justify-content-between">
            {li.props.children as Iterable<ReactNode>}
            <div className="icons-wrapper">
                {dataItem._isDefault && <FontAwesomeIcon icon={['far', 'asterisk']} className="asterisk" />}
                {dataItem.favourite && <FontAwesomeIcon icon={['fas', 'star']} />}
            </div>
        </div>
    );

    // Disabled in 2027.1 tech debt sprint, to allow adding tighter eslint rules
    // eslint-disable-next-line @eslint-react/no-clone-element
    return React.cloneElement(li, li.props, itemChildren);
};
